import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-button" }
const _hoisted_2 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mobile-bottom-bar", _ctx.variant])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "no-load",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
      }),
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, {
          icon: "plus",
          size: "2x"
        })
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "left" }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "middle" }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "right" }, null, -1))
  ], 2))
}